import { render, staticRenderFns } from "./NotificationPermissionWizard.vue?vue&type=template&id=3781116b"
import script from "./NotificationPermissionWizard.vue?vue&type=script&lang=ts"
export * from "./NotificationPermissionWizard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports